// extracted by mini-css-extract-plugin
export default {"root":"TodayDetail_root__Hxyv5","section":"TodayDetail_section__dPHNe","temp":"TodayDetail_temp__OsJbZ","detail":"TodayDetail_detail__uNwpy"};